import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./shared/ui/Layout";
import { AuthGate } from "./shared/auth/AuthGate";
import { AuthProvider } from "./shared/auth/AuthProvider";
import { ExportRoute } from "./routes/ExportRoute";
import { LoginRoute } from "./routes/LoginRoute";
import { NotFoundRoute } from "./routes/NotFoundRoute";
import { StudyRoute } from "./routes/StudyRoute";
import { StudyFamilyRoute } from "./routes/StudyFamilyRoute";
import { StudyAsksRoute } from "@/routes/StudyAsksRoute";
import { StudyNotesRoute } from "@/routes/StudyNotesRoute";
import { StudySourceReaderRoute } from "./routes/StudySourceReaderRoute";
import { StudyAidRoute } from "./routes/StudyAidRoute";
import { StudyGuidesRoute } from "./routes/StudyGuidesRoute";
import { StudySourceIndexRoute } from "./routes/StudySourceIndexRoute";
import { StudyKikiwakeRoute } from "./routes/StudyKikiwakeRoute";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            {/* 直近の主用途はいちごスタディなので、トップは /study へ寄せる (エクスポートは /export 直打ちで開ける) */}
            <Route path="/" element={<Navigate to="/study" replace />} />
            <Route path="/login" element={<LoginRoute />} />
            <Route
              path="/export"
              element={
                <AuthGate>
                  <ExportRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study"
              element={
                <AuthGate>
                  <StudyRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId"
              element={
                <AuthGate>
                  <StudyFamilyRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId/notes"
              element={
                <AuthGate>
                  <StudyNotesRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId/asks"
              element={
                <AuthGate>
                  <StudyAsksRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId/sources/:sourceId"
              element={
                <AuthGate>
                  <StudySourceReaderRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId/sources/:sourceId/index"
              element={
                <AuthGate>
                  <StudySourceIndexRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId/sources/:sourceId/guides/:problemId?"
              element={
                <AuthGate>
                  <StudyGuidesRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId/sources/:sourceId/aids/:aidId"
              element={
                <AuthGate>
                  <StudyAidRoute />
                </AuthGate>
              }
            />
            <Route
              path="/study/:familyId/kikiwake/:personId"
              element={
                <AuthGate>
                  <StudyKikiwakeRoute />
                </AuthGate>
              }
            />
            <Route path="/404" element={<NotFoundRoute />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}
